import { render, staticRenderFns } from "./sobre.vue?vue&type=template&id=d8413cda"
import script from "./sobre.vue?vue&type=script&lang=js"
export * from "./sobre.vue?vue&type=script&lang=js"
import style0 from "./sobre.vue?vue&type=style&index=0&id=d8413cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports